<template>
	<div class="d-flex fill-height fill-width">
		<slot />
	</div>
</template>

<script>
export default {};
</script>
